import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import FleetSection from './components/FleetSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import AdminApp from './components/AdminApp';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Router>
          <Routes>
            {/* Route principale du site */}
            <Route path="/" element={
              <>
                <Header />
                <HeroSection />
                <ServicesSection />
                <FleetSection />
                <AboutSection />
                <ContactSection />
                <Footer />
                <Toaster />
              </>
            } />
            
            {/* Route d'administration */}
            <Route path="/admin" element={<AdminApp />} />
          </Routes>
        </Router>
      </div>
    </LanguageProvider>
  );
}

export default App;